export default __webpack_public_path__ + "214d2f793ddadba4abee0f8168def8fe.svg";